import { render, staticRenderFns } from "./LessonSlideViewerComponent.vue?vue&type=template&id=e9765f48&scoped=true&"
import script from "./LessonSlideViewerComponent.vue?vue&type=script&lang=js&"
export * from "./LessonSlideViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./LessonSlideViewerComponent.vue?vue&type=style&index=0&id=e9765f48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9765f48",
  null
  
)

export default component.exports